<app-page>
  <section class="delete_prompt_wrapper">
    <mat-card appearance="outlined">
      <div mat-card-avatar>
        <mat-icon>warning</mat-icon>
      </div>
      <div>
        <mat-card-title
          >Organization needs a subscription to continue!</mat-card-title
        >
        <mat-card-content>
          <p>
            Contact
            <a href="mailto:support@myrobot.cloud">support@myrobot.cloud</a> to
            purchase a subscription.
          </p>
        </mat-card-content>
        <mat-card-actions style="margin-top: 2em">
          <button mat-raised-button color="accent" (click)="navigateToHome()">
            Select organization
          </button>
        </mat-card-actions>
      </div>
    </mat-card>
  </section>
</app-page>
